import React, { useContext } from "react";
import pptpage from "./pptpage.pdf";
// import drive_erc from "../Driveanalysis/Drive_Erc.pdf";
import drive_erc from "./DriveErc.pdf"
import DashboardMain_Coral from "../DashboardMain_Coral/DashboardMain_Coral";
import AppContext from "../../../store/AppContext";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

function PPTPage_Coral() {
  const app_ctx = useContext(AppContext);

  const loggedInUser = useSelector(selectLoggedInUser);
  return (
    <>
      <DashboardMain_Coral>

        {loggedInUser.flagForHideShow !== "ERC" ? (
          <iframe
            src={pptpage}
            style={{ marginTop: "7%" }}
            frameborder="0"
            height="500em"
            width="100%"
            sandbox
          ></iframe>
        ) : (
          <iframe
            src={drive_erc}
            style={{ marginTop: "7%" }}
            frameborder="0"
            height="500em"
            width="100%"
            sandbox
          ></iframe>
        )}
      </DashboardMain_Coral>
    </>
  );
}

export default PPTPage_Coral;
